import { post } from "helpers/api_helper";
import * as URL from "helpers/url_helper"

export const callUserSignUp = data => post(URL.SIGN_UP, data, { skipInterceptor: true });
export const callVerifySignUp = data => post(URL.VERIFY_OTP, data, { skipInterceptor: true });
export const callResendOTP = data => post(URL.RE_SEND_OTP, data, { skipInterceptor: true });
export const callBulkAddUser = data => post(URL.POST_BULK_REGISTER, data);
export const callBulkFileUpload = data => post(URL.Bulk_USER_FILE_UPLOAD, data);
export const callgetFileByBatch = data => post(URL.GET_FILE_BY_BATCH, data);
export const callGetAllFileData = data => post(URL.GET_ALL_FILE_DATA, data)
export const callGetAllFileDataCount = data => post(URL.GET_FILE_COUNT, data)
export const callgetFileByFileId = data => post(URL.GET_FILE_BY_FILEID, data);
export const callUplodBulkOrder = data => post(URL.BULK_UPLOAD, data);
export const callUplodBulkTarget = data => post(URL.BULK_TARGET_UPLOAD, data);
export const callUplodBulkOrderCart = data => post(URL.BULK_UPLOAD_CART, data);
export const callUplodBulkOrderReq = data => post(URL.BULK_UPLOAD_ORDER_REQ, data);
export const callUplodBulkUploadOrderTargetReq = data => post(URL.BULK_UPLOAD_ORDER_TARGET_REQ, data);
export const callUplodBulkOrderEmployee = data => post(URL.BULK_UPLOAD_EMPLOYEE, data);
export const callgetFileById = data => post(URL.GET_FILE_BY_ID, data);
export const callBulkCreateUser = data => post(URL.CREATE_BULK_USER, data);